import { render, staticRenderFns } from "./UserAmount.vue?vue&type=template&id=673e370d&scoped=true"
import script from "./UserAmount.vue?vue&type=script&lang=js"
export * from "./UserAmount.vue?vue&type=script&lang=js"
import style0 from "./UserAmount.vue?vue&type=style&index=0&id=673e370d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "673e370d",
  null
  
)

export default component.exports